/**      
 * 
 *  易税云搜索区机构树组件
 *  @author:    <sujingjun@467794164@qq.com>
 *  @date:      2018年5月02日
 *  email: 467794164@qq.com
 *  @param orglist 数据数组
 *  @param orgChange 数据变化
 *  @param cascade 是否级联  选中父级,子级全部选中,取消父级,子级全部取消
 *  @param config: 配置check类型
  * @param queryJson：{
        queryName： 字段名称
        queryKey： 字段id
        queryType： 展示类型 tree 树状，Flater扁平
        multiple： 是否多选
        parentId: 上级id
        parentIdName 上级字段名称
        defaultSelect 默认选中
  } 组件配置
 *  @version:   1.0
 *  @checkAll:   增加全选功能
 *  @node-reset:   全选或者取消全选 节点选择取消功能 外部命令操作
 *  @queryName:   根据不同数据改造相同queryName属性orgName
 *  @inputSearch: 增加搜索框   
 *  @nodeReset: 重置操作功能
 * @author:    <liYunPeng>
 */

import template from './view.html';
import './orgTreeSearch.less';
import angular from 'angular';
import { data } from 'jquery';

export default function orgTreeSearchDirective(
  logger,
  $timeout,
  httpRequest,
  $uibModal
) {
  return {
    restrict: 'EA',
    scope: {
      treeData: '<',
      defaultSelect: '<',
      selectedList: '=',
      orgChange: '=',
      config: '<',
      name: '@',
      nodeReset: '@',
      isCheckAll: '=',
    },
    template,
    link(scope) {
      scope.$watch('treeData', function (newValue, oldValue) {
        if (newValue) {
          scope.newTreeData = newValue;
        }
      });

      scope.open = function () {
        scope.searchNode = true;
        scope.hasSearchFocus = true;
        scope.hasSearchVal = true;
      };
      scope.close = function () {
        if (!scope.searchNode) return;
        scope.searchNode = true;
        scope.hasSearchFocus = false;
        scope.hasSearchVal = false;
      };
      scope.searchOpen = function searchOpen() {
        scope.searchNode = false;
        scope.hasSearchFocus = true;
        scope.hasSearchVal = true;
      };
      scope.$on('node-change', function (event, data) {
        scope.orgChange && scope.orgChange(data);
      });

      // scope.$on('treeSelectChange',function(){

      //     scope.selectedList = scope.treeVal
      //     scope.$apply()

      // })
    },
    controller: [
      '$scope',
      function ($scope) {
        $scope.$on($scope.nodeReset, function (event, data) {
          $scope.selectedList = [];
          $scope.nodeCheckReset = $scope.nodeReset;
          $scope.selectedList = data;
        });
        $scope.checkAll = function (value) {
          console.log($scope.nodeReset);
          if (!value) {
            $scope.selectedList = [];
          } else {
            angular.forEach($scope.treeData, (item, index) => {
              item.checked = Boolean(value);
            });
            $scope.selectedList = $scope.treeData;
          }
          $scope.isCheckAll && $scope.isCheckAll($scope.selectedList);
        };
      },
    ],
  };
}
orgTreeSearchDirective.$inject = [
  'logger',
  '$timeout',
  'httpRequest',
  '$uibModal',
];



// WEBPACK FOOTER //
// ./src/components/orgTreeSearch/orgTreeSearchDirective.js